import { Button, Form, Row, Space, theme } from "antd";
import FormItem from "../../form/form-item";
import { useCallback, useEffect } from "react";
import { useGetDomesticAidsQuery } from "../../../../api/plamo-api";
import PlamoApiWithSaveNotifications from "../../util/with-save-notification";

import { DeleteOutlined } from "@ant-design/icons";
import { AdvancedForm, useAdvancedFormContext } from "../../form/advanced-form";

const { useCreateDomesticAidWithSaveNotificationMutation, useUpdateDomesticAidWithSaveNotificationMutation, useDeleteDomesticAidWithSaveNotificationMutation } = PlamoApiWithSaveNotifications;


const AddDomesticAidButton = ({ onClick }) => {
  const advancedFormContext = useAdvancedFormContext()

  return (
    <Button onClick={onClick} disabled={advancedFormContext.readOnly}>
      Folgebewilligung hinzufügen
    </Button>
  )
}

const DeleteButton = ({ onClick }) => {
  const advancedFormContext = useAdvancedFormContext()

  return (
    <Button icon={<DeleteOutlined />} onClick={onClick} disabled={advancedFormContext.readOnly} />
  )
}

function CustomerDomesticAid({ customerId }) {
  const [form] = Form.useForm();
  const { data } = useGetDomesticAidsQuery({ f: JSON.stringify({ "customer.id": { c: "EQ", v: customerId }}), st: JSON.stringify({ id: 'asc' }) }) as any
  const [ createDomesticAid, { isLoading: isCreatingRelative } ] = useCreateDomesticAidWithSaveNotificationMutation();
  const [ updateDomesticAid, { isLoading: isUpdatingRelative } ] = useUpdateDomesticAidWithSaveNotificationMutation();
  const [ deleteDomesticAid, { isLoading: isDeletingRelative } ] = useDeleteDomesticAidWithSaveNotificationMutation();
  //const relatives = useMemo(() => data.items || [], [data])

  const isLoading = isCreatingRelative || isUpdatingRelative || isDeletingRelative;

  const { token } = theme.useToken();

  const formStyle: React.CSSProperties = {
    maxWidth: 'none',
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  useEffect(() => {
      form.setFieldsValue(data)
  }, [form, data])

  const onFinish = useCallback(async (values: any) => {
    console.log('On finish', values);
    const promisesCreateUpdate = values.items.map(i => {
      console.log("Creating / updating relative", i);
      if(i.id) {
        return updateDomesticAid(i);
      } else {
        return createDomesticAid(i);
      }
    })

    const promisesDelete = data.items.filter(i => !values.items.find(i2 => i.id === i2.id)).map(i => deleteDomesticAid(i));
    
    await Promise.all([...promisesCreateUpdate, ...promisesDelete]);
  }, [createDomesticAid, updateDomesticAid, deleteDomesticAid, data]);

  return (<AdvancedForm form={form} name="relatives" style={formStyle} onFinish={onFinish} originalValues={data} isLoading={isLoading}>
    <Form.List name="items">
      {(fields, { add, remove }, { errors }) => <>{
        fields.map((field, index) => { return <>
          <Row><h3>Bewilligung { index + 1 } <DeleteButton  onClick={() => remove(index)} /></h3></Row>
          <Row gutter={24}>
            <FormItem field={field} fieldName="fromDate" label="von" type="date"/>
            <FormItem field={field} fieldName="untilDate" label="bis" type="date"/>
          </Row>
          <Row gutter={24}>
            <FormItem field={field} fieldName="hoursPerWeek" label="Std pro Woche" type="number"/>
            <FormItem field={field} fieldName="hoursPerDay" label="Std pro Tag" type="number"/>
          </Row>
          <Row gutter={24}>
            <FormItem field={field} fieldName="days" label="Wochentage" type="daysOfWeek" />
          </Row>
        </>})}
        <div style={{ textAlign: 'right', marginBottom: '24px' }}>
          <Space size="small">
            <AddDomesticAidButton onClick={() => add({ customerId })} />
          </Space>
        </div>
        </>
      }
    </Form.List> 
    </AdvancedForm>)
}

export default CustomerDomesticAid